import styled from 'styled-components';
import Form from '../../../../components/FormWrapper';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SelectorLabel = styled.label`
  font-family: 'Unimed-Sans-SemiBold', sans-serif;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.palet.institutional || '#00995D'};
  font-weight: 600;
  margin-bottom: 16px;
  display: block;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 14px;
  }
`;

export const FormWrapper = styled(Form)`
  display: flex !important;
  flex-wrap: wrap;

  .text-bold {
    div {
      position: relative;

      input {
        font-weight: 600;
        font-family: 'Unimed-Sans-SemiBold', sans-serif;
        border-radius: 16px;
        border: 2px solid rgba(0, 153, 93, 0.2);
        padding: 16px 20px;
        font-size: 1.1rem;
        transition: all 0.3s ease;
        background: rgba(248, 255, 254, 0.8);
        color: ${(props) => props.theme.colors.text.primary || '#333'};
        width: 100%;

        &:hover {
          border-color: rgba(0, 153, 93, 0.4);
          background: rgba(248, 255, 254, 1);
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(0, 153, 93, 0.1);
        }

        &:focus {
          border-color: ${(props) =>
            props.theme.colors.palet.institutional || '#00995D'};
          box-shadow: 0 0 0 4px rgba(0, 153, 93, 0.15);
          background: white;
          transform: translateY(-2px);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        @media (max-width: 768px) {
          padding: 14px 18px;
          font-size: 1rem;
          border-radius: 14px;
        }
      }

      /* Estilo para o dropdown */
      .react-select__control {
        border-radius: 16px !important;
        border: 2px solid rgba(0, 153, 93, 0.2) !important;
        padding: 8px 12px !important;
        font-size: 1.1rem !important;
        transition: all 0.3s ease !important;
        background: rgba(248, 255, 254, 0.8) !important;
        box-shadow: none !important;

        &:hover {
          border-color: rgba(0, 153, 93, 0.4) !important;
          background: rgba(248, 255, 254, 1) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(0, 153, 93, 0.1) !important;
        }

        &.react-select__control--is-focused {
          border-color: ${(props) =>
            props.theme.colors.palet.institutional || '#00995D'} !important;
          box-shadow: 0 0 0 4px rgba(0, 153, 93, 0.15) !important;
          background: white !important;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          padding: 6px 10px !important;
          font-size: 1rem !important;
          border-radius: 14px !important;
        }
      }

      .react-select__value-container {
        padding: 0 8px !important;
      }

      .react-select__single-value {
        font-family: 'Unimed-Sans-SemiBold', sans-serif !important;
        font-weight: 600 !important;
        color: ${(props) =>
          props.theme.colors.text.primary || '#333'} !important;
      }

      .react-select__placeholder {
        font-family: 'Unimed-Sans-Regular', sans-serif !important;
        color: ${(props) =>
          props.theme.colors.text.secondary || '#666'} !important;
      }

      .react-select__menu {
        border-radius: 12px !important;
        box-shadow: 0 8px 32px rgba(0, 153, 93, 0.15) !important;
        border: 1px solid rgba(0, 153, 93, 0.1) !important;
      }

      .react-select__option {
        font-family: 'Unimed-Sans-Regular', sans-serif !important;

        &:hover {
          background: rgba(0, 153, 93, 0.1) !important;
        }

        &.react-select__option--is-selected {
          background: ${(props) =>
            props.theme.colors.palet.institutional || '#00995D'} !important;
        }
      }
    }
  }
`;
